<template>
  <div class="document-gen">
    <div class="document-single">
      <div class="section-block left-block">
        <div class="section-title">文书生成</div>
        <el-form ref="formRef" :model="form" :rules="auxRules" label-width="100px" class="section-form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="文书类型" prop="typeCode">
                <el-select
                    v-model="form.typeCode"
                    placeholder="请选择文书类型"
                    clearable
                    class="doc-type-select"
                >
                  <el-option
                      v-for="item in documentTypeOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          <el-col :span="12">
            <el-form-item label="认定书文号">
              <el-input v-model="form.referenceNumber" placeholder="例如：1" />
            </el-form-item>
          </el-col>
          </el-row>
        </el-form>

        <!-- 文书内容预览：PDF/图片展示 -->
        <div class="preview-wrap" v-if="false">
          <div class="preview-title">文书内容预览</div>
          <div class="preview-content" v-loading="previewLoading">
            <!-- PDF 用 iframe 展示 -->
            <template v-if="previewUrl && isPdfUrl(previewUrl)">
              <iframe
                  :key="previewUrl"
                  :src="resolvePreviewUrl(previewUrl)"
                  class="preview-iframe"
                  title="文书预览"
              />
            </template>
            <!-- 图片用 img 展示 -->
            <template v-else-if="previewUrl && isImageUrl(previewUrl)">
              <img
                  :key="previewUrl"
                  :src="resolvePreviewUrl(previewUrl)"
                  class="preview-img"
                  alt="文书预览"
              />
            </template>
            <!-- 无内容时占位 -->
            <div v-else class="preview-empty">
              <span>请选择文书类型并生成文书</span>
            </div>
          </div>
        </div>
        <div class="action-btns">
          <el-button type="primary" :loading="refreshLoading" @click="handleSubmit(1)">预览文书</el-button>
          <el-button type="success" @click="handleSubmit(2)">下载文书</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getListByDictType} from '@/api/sys/dictData'
import {generateDocument} from '@/api/recognition/survey'
import {downLoadFile, previewFile, getBlobErrorMsg, isBlobErrorResponse} from '@/utils/downLoad'
export default {
  name: 'DocumentGen',
  data() {
    return {
      form: {
        typeCode: '',
        generateType:1,
        referenceNumber:''
      },
      auxRules: {
        typeCode: [{required: true, message: '请选择文书类型', trigger: 'change'}],
      },
      documentTypeOptions: [],
      previewUrl: '',
      previewLoading: false,
      refreshLoading: false,
      generateLoading: false
    }
  },
  created() {
    this.loadDictData()
  },
  methods: {
    async loadDictData() {
      try {
        const res = await getListByDictType('industrial_injury_inquiry_document_type')
        if (res && res.code === 200 && res.data) {
          this.documentTypeOptions = res.data
        }
      } catch (e) {
        console.warn('文书类型字典加载失败', e)
      }
    },
    resolvePreviewUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      const prefix = this.imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || ''
      return prefix + url
    },
    isPdfUrl(url) {
      if (!url) return false
      const u = (url || '').toLowerCase()
      return u.includes('.pdf') || u.includes('application/pdf')
    },
    isImageUrl(url) {
      if (!url) return false
      const u = (url || '').toLowerCase()
      return /\.(jpg|jpeg|png|gif|webp)(\?|$)/.test(u) || u.includes('image/')
    },
    handleRefreshPreview(response) {
      previewFile(response)
    },
    handleDownloadCurrent(response) {
      downLoadFile(response,this.form.typeName,this.form.referenceNumber)
    },
    handleSubmit(state){
      this.$refs.formRef.validate().then(valid=>{
        if(!valid){
          return
        }
        this.form.type=state;
        this.form.typeName=this.selectDictLabel(this.documentTypeOptions,this.form.typeCode);
        let caseId=this.$route.query.id;
        if(!caseId)return;
        this.form.caseId=caseId;
        generateDocument(this.form).then(async (res) => {
          if (isBlobErrorResponse(res)) {
            const errorMsg = await getBlobErrorMsg(res, '文书生成失败')
            return this.$message.error(errorMsg)
          }
          if (res) {
            if (state == 2) {
              this.handleDownloadCurrent(res)
            } else {
              this.handleRefreshPreview(res)
            }
          }
        }).catch((error) => {
          this.$message.error(error?.message || error?.msg || '文书生成失败')
        }).finally(() => {
          this.handleClose()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.document-gen {
  width: 100%;
  height: 100%;
}

.document-single {
  flex: 1;
}

.section-block {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 0;

  .section-title {
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding-left: 11px;
    margin-bottom: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 12px;
      border-radius: 20px;
      background: var(--vt-c-blue, #409eff);
    }
  }
}

.left-block {
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.doc-type-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .doc-type-label {
    font-size: 14px;
    color: #606266;
    flex-shrink: 0;
  }

  .doc-type-select {
    flex: 1;
    max-width: 320px;
  }
}

.preview-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 320px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fafafa;
}

.preview-title {
  padding: 8px 12px;
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.preview-content {
  flex: 1;
  position: relative;
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-iframe {
  width: 100%;
  height: 100%;
  min-height: 400px;
  border: none;
}

.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.preview-empty {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 40px 20px;
}

.action-btns {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

</style>
